const BellIcon = ({clr, isActive}) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none">
    <path
      stroke="#FFFDEA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      fill={isActive ? "#fff" :"none"}
      d="M5.269 10.5a6.731 6.731 0 1 1 13.463 0v0c0 3.358.702 5.306 1.32 6.371a.75.75 0 0 1-.644 1.13H4.592a.751.751 0 0 1-.645-1.13c.62-1.065 1.322-3.013 1.322-6.37h0Z"
    />
    <path
      stroke="#FFFDEA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9 18v.75a3 3 0 0 0 6 0V18M17.197 2.249a9.794 9.794 0 0 1 3.555 3.948M3.249 6.197A9.794 9.794 0 0 1 6.803 2.25"
    />
  </svg>
)

export default BellIcon